import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter, matchPath } from "react-router-dom";
import { useEffect } from "react";
import {
  lockAppUntilAccountAddressUpdated,
  lockAppUntilAccount2FaEnabled,
  getUserId,
} from "../../utilities/localStorage";
import { uiNotification } from "../../services/UINotificationService";

const ALLOWED_ROUTES = [
  // Added allowed routes for on hold or canceled account status
  "/settings/manage-subscription",
  "/settings/manage-invoices",
  "/settings/resource-usage",
  "/dashboard/user-logs",
  "/settings/manage-subscription-upgrade",
];
const ALLOWED_ROUTES_PROFILE = [
  // Added allowed routes for disabled 2FA status
  "/settings/profile",
  "/logout",
];

const ALLOWED_ROUTES_WORKSPACE = [
  // Added allowed routes until workspace is selected
  "/workspaces",
  "/logout",
];

const REDIRECT_TO = ALLOWED_ROUTES[0];

function AccountStatusRedirect(props) {
  function redirectToAllowedRoute(location) {
    const isOnAllowedRoute = () => {
      if (!getUserId()) {
        return Boolean(
          matchPath(location.pathname, { path: ALLOWED_ROUTES_WORKSPACE }),
        );
      } else if (lockAppUntilAccount2FaEnabled.get()) {
        return Boolean(
          matchPath(location.pathname, { path: ALLOWED_ROUTES_PROFILE }),
        );
      } else {
        return Boolean(matchPath(location.pathname, { path: ALLOWED_ROUTES }));
      }
    };

    if (!getUserId()) {
      if (!isOnAllowedRoute()) {
        props.history.push(ALLOWED_ROUTES_WORKSPACE[0]);
      }
    } else if (lockAppUntilAccount2FaEnabled.get()) {
      if (!props.isAccount2FaEnabled && !isOnAllowedRoute()) {
        uiNotification.error("Action Needed: Enable 2FA");
        props.history.push(ALLOWED_ROUTES_PROFILE[0]); // Redirect to profile settings page if 2FA is not enabled
      }
    } else if (!lockAppUntilAccountAddressUpdated.get()) {
      if (
        (props.isAccountOnHold || props.isAccountCancelled) &&
        !isOnAllowedRoute()
      ) {
        props.history.push(REDIRECT_TO); // Redirect to manage-subscription page if account status is on hold or canceled
      }
    }
  }

  useEffect(() => {
    redirectToAllowedRoute(props.location);
  }, [props.isAccountOnHold, props.isAccount2FaEnabled]);

  useEffect(() => {
    return props.history.listen(redirectToAllowedRoute);
  }, [redirectToAllowedRoute]);

  return null;
}

function mapStateToProps(state) {
  return {
    isAccountOnHold: state.AccountHoldRedirectReducer.isAccountOnHold,
    isAccountCancelled: state.AccountHoldRedirectReducer.isAccountCancelled,
    isAccount2FaEnabled: state.AccountHoldRedirectReducer.isAccount2FaEnabled,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(AccountStatusRedirect));
